/**
 * Stylized mockup of the NIS360 AI assistant used as a screenshot stand-in on
 * marketing pages. Texts are intentionally hardcoded German, exactly like a
 * real product screenshot would be.
 */
export default function AssistantMockup() {
	return (
		<div className="flex flex-col gap-3">
			<div className="flex items-center gap-2">
				<span className="w-7 h-7 rounded-full bg-plum text-white text-[10px] font-bold flex items-center justify-center font-urbanist">
					KI
				</span>
				<p className="font-urbanist text-[13px] font-bold text-ink">NIS-2 KI-Assistent</p>
				<span className="ml-auto font-urbanist text-[9px] font-semibold text-text bg-success-light rounded-full px-2 py-0.5">
					Im Kontext Ihrer Aufgabe
				</span>
			</div>
			<div className="flex flex-col gap-2">
				<div className="self-end max-w-[85%] bg-ink text-white rounded-2xl rounded-br-md px-3 py-2">
					<p className="font-urbanist text-[11px] leading-[150%]">
						Reicht unser bestehendes Backup-Konzept für die NIS-2-Anforderungen aus?
					</p>
				</div>
				<div className="self-start max-w-[90%] bg-surface border border-border rounded-2xl rounded-bl-md px-3 py-2">
					<p className="font-urbanist text-[11px] text-ink leading-[150%]">
						Für diese Aufgabe verlangt § 30 BSIG ein dokumentiertes Backup-Management. Prüfen Sie
						drei Punkte: regelmäßige Wiederherstellungstests, räumlich getrennte Aufbewahrung und
						definierte Wiederanlaufzeiten. Eine Vorlage finden Sie direkt in der Aufgabe.
					</p>
				</div>
				<div className="self-start flex items-center gap-1.5 px-1">
					<span className="font-urbanist text-[9px] text-subtle">
						Quellen: BSIG · BSI-Grundschutz · ISO 27001
					</span>
				</div>
			</div>
		</div>
	);
}
